module.exports = __webpack_public_path__ + "static/media/Mask Group 161.68ea06aa.svg";